// src/Redux/slices/assistantSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { sendAssistantMessage } from "../thunks/assistantThunks";

const initialState = {
    status: "idle", // idle | loading | succeeded | failed
    lastReply: null, // { message, links, meta }
    error: null,
};

const assistantSlice = createSlice({
    name: "assistant",
    initialState,
    reducers: {
        resetAssistantState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendAssistantMessage.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(sendAssistantMessage.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.lastReply = action.payload;
            })
            .addCase(sendAssistantMessage.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || { error: "unknown_error" };
            });
    },
});

export const { resetAssistantState } = assistantSlice.actions;
export default assistantSlice.reducer;